import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EmporixSdkService } from 'haba-emporix';

export interface PostalCodeSearchResponse {
  postalCode: string;
  city: string;
  fieldServiceEmployee: string;
  email: string;
  phone: string;
  image: string;
}

@Injectable({
  providedIn: 'root',
})
export class PostalCodeService {
  constructor(
    private http: HttpClient,
    private emporixSdkService: EmporixSdkService
  ) {}

  public getContactByPostalCode(postalCode: string) {
    const url = this.emporixSdkService.buildSdkUrl('postalCodeSearch');
    const params = { postalCode };

    return this.http.get<PostalCodeSearchResponse>(url, { params });
  }
}
